import { default as Lesson1 } from "./lesson-1.json"

export const hs = {
    "audioPrefix": "hsct",
    days: [...Lesson1].map(d => {
        if (d.prefix && !Array.isArray(d.prefix)) { d.prefix = [d.prefix] }
        if (d.suffix && !Array.isArray(d.suffix)) { d.suffix = [d.suffix] }
        return d
    }),
    "timer": {
        "day4": { "rio": 30 },
        "day3": { "cOpts": 60 * 3 }
    }
}
